"use client";

import { Stack, Typography } from "@mui/material";
import { useFeeQuotes } from "modules/bridge/hooks/useFeeQuotes";

interface Props {
  destination: string;
  tokenIndex: number;
}

export const Fee = ({ destination, tokenIndex }: Props) => {
  const { fees } = useFeeQuotes(
    {
      destination,
      tokenIndex,
    },
    true
  );

  return (
    <Stack sx={{ flexDirection: "row", justifyContent: "space-between" }}>
      <Typography variant="body1" color="text.disabled">
        Estimated Fee
      </Typography>

      <Typography variant="body1" color="text.disabled">
        {fees?.getDecimalFormattedAmount()} {fees?.token.symbol}
      </Typography>
    </Stack>
  );
};
